import React from 'react';
import { Card, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';

function BankAccountSkeleton(): JSX.Element {
  return (
    <Card>
      <DataList bottomDivider={false}>
        <DataList.Row
          topDivider={false}
          paddingX="none"
          paddingBottom="2"
          paddingTop="none"
        >
          <Text.Skeleton />
        </DataList.Row>
        <DataList.Row paddingX="none" paddingY="2">
          <Text.Skeleton />
        </DataList.Row>
        <DataList.Row paddingX="none" paddingY="2">
          <Text.Skeleton />
        </DataList.Row>
        <DataList.Row paddingX="none" paddingTop="2" paddingBottom="none">
          <Text.Skeleton />
        </DataList.Row>
      </DataList>
    </Card>
  );
}

export default BankAccountSkeleton;
